import PropTypes from "prop-types";

import SearchSelect from "./SearchSelect";

/* Labelled wrapper around SearchSelect, mirroring FieldSelect's rec-field layout. */
export default function FieldSearchSelect({
  label,
  value,
  onChange,
  options,
  hint,
  placeholder,
  searchPlaceholder,
  disabled,
}) {
  return (
    <div className="rec-field">
      {/* SearchSelect is a custom button-based widget, not a native control,
          so the label cannot use htmlFor association. */}
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      {label && <label>{label}</label>}
      <SearchSelect
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        disabled={disabled}
      />
      {hint && <small>{hint}</small>}
    </div>
  );
}

FieldSearchSelect.propTypes = {
  label: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.array.isRequired,
  hint: PropTypes.node,
  placeholder: PropTypes.node,
  searchPlaceholder: PropTypes.string,
  disabled: PropTypes.bool,
};

FieldSearchSelect.defaultProps = {
  label: null,
  value: undefined,
  onChange: undefined,
  hint: null,
  placeholder: undefined,
  searchPlaceholder: undefined,
  disabled: false,
};
